<template>
  <div class="mb20 price">
    <div
      class="h3 cl-secondary"
      v-if="initialPrice.special && price.default && price.original"
    >
      <span
        class="h2 cl-black weight-700"
      >{{ price.special | price(storeView) }}</span>&nbsp;
      <span
        class="price-original h3"
      >{{ price.original | price(storeView) }}</span>
    </div>
    <div
      class="h3 cl-black weight-700"
      v-if="!initialPrice.special && price.default"
    >
      {{ price.default | price(storeView) }}
    </div>
  </div>
</template>
<script>
import productPrice from 'theme/mixins/productPrice.ts'

export default {
  name: 'ProductPrice',
  mixins: [productPrice],
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    customOptions: {
      type: Object,
      default: () => ({})
    }
  },
 
}
</script>
<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-primary: color(primary);
.price-original {
  text-decoration: line-through;
}

.price {
  @media (max-width: 767px) {
    color: $color-primary;
  }
}
</style>
